(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/store/deposit-slice.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/store/deposit-slice.js');
'use strict';

var _svs$accountservicesR, _svs$accountservicesR2, _svs, _svs$accountservicesR3, _svs$accountservicesR4;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const paymentTypes = svs.accountservicesReact.deposit.constants.paymentTypes;
const PERIODS = svs.accountservicesReact.deposit.depositLimits.constants.PERIODS;
const instantPayInitialState = ((_svs$accountservicesR = svs.accountservicesReact.deposit) === null || _svs$accountservicesR === void 0 || (_svs$accountservicesR = _svs$accountservicesR.data) === null || _svs$accountservicesR === void 0 ? void 0 : _svs$accountservicesR.instantPay) || undefined;
const maxLimits = ((_svs$accountservicesR2 = svs.accountservicesReact.deposit) === null || _svs$accountservicesR2 === void 0 || (_svs$accountservicesR2 = _svs$accountservicesR2.data) === null || _svs$accountservicesR2 === void 0 ? void 0 : _svs$accountservicesR2.maxLimits) || undefined;
const returnUrl = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservicesReact) === null || _svs === void 0 || (_svs = _svs.deposit) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.returnUrl) || undefined;
const lastPaymentMethod = svs.components.Storage.browser.get('lastPaymentMethod', 'transactions') || ((_svs$accountservicesR3 = svs.accountservicesReact.deposit) === null || _svs$accountservicesR3 === void 0 || (_svs$accountservicesR3 = _svs$accountservicesR3.data) === null || _svs$accountservicesR3 === void 0 ? void 0 : _svs$accountservicesR3.lastPaymentMethod) || null;
const transactionLimits = ((_svs$accountservicesR4 = svs.accountservicesReact.deposit) === null || _svs$accountservicesR4 === void 0 || (_svs$accountservicesR4 = _svs$accountservicesR4.data) === null || _svs$accountservicesR4 === void 0 || (_svs$accountservicesR4 = _svs$accountservicesR4.transactionLimits) === null || _svs$accountservicesR4 === void 0 ? void 0 : _svs$accountservicesR4.limits) || PERIODS.map(i => ({
  limitType: i
}));
const userSessionRemoveAsync = () => new Promise(resolve => {
  svs.core.userSession.remove('depositInstantPayInfo', resolve);
});
const saveInstantPayToUserSession = instantPay => {
  svs.core.userSession.set('depositInstantPayInfo', instantPay);
};
const instantPayClear = RTK.createAsyncThunk('deposit/instantPayClear', async () => {
  await userSessionRemoveAsync();
  return {
    status: 'success',
    error: null,
    data: null
  };
});
const selectDespositmethod = method => {
  if (Object.values(paymentTypes).includes(method)) {
    return method;
  }
  return lastPaymentMethod;
};

const getInitialState = () => ({
  selectedDepositMethod: selectDespositmethod(lastPaymentMethod),
  instantPay: instantPayInitialState,
  isDepositAndPay: false,
  amount: '',
  transactionLimits,
  returnUrl,
  maxLimits: maxLimits !== null && maxLimits !== void 0 ? maxLimits : {}
});
const depositSlice = RTK.createSlice({
  name: 'deposit',
  initialState: getInitialState(),
  reducers: {
    selectedDepositMethodChange: (state, action) => {
      state.selectedDepositMethod = selectDespositmethod(action.payload);
    },
    instantPayChange: (state, action) => {
      if (typeof action.payload === 'object') {
        state.instantPay = action.payload;
        saveInstantPayToUserSession(_objectSpread({}, state.instantPay));
      }
    },
    instantPayAmountChange: (state, action) => {
      var _state$instantPay;
      if ((_state$instantPay = state.instantPay) !== null && _state$instantPay !== void 0 && _state$instantPay.amount) {
        state.instantPay.amount = action.payload;
        saveInstantPayToUserSession(_objectSpread({}, state.instantPay));
      }
    },
    amountChangeAction: (state, action) => {
      state.amount = action.payload;
    },
    returnUrlChange: (state, action) => {
      state.returnUrl = action.payload;
    },
    accountBalanceChangeAction: (state, action) => {
      state.accountBalance = action.payload;
    },
    clearFormsDataAction: state => {
      state.amount = getInitialState().amount;
    },
    transactionLimitsChange: (state, action) => {
      state.transactionLimits = action.payload;
    },
    updateSpendLimitRemainingAction: (state, action) => {
      const oldLimit = parseInt(state.maxLimits.spendLimitRemaining, 10);
      const newLimit = String(oldLimit - action.payload); 
      state.maxLimits = _objectSpread(_objectSpread({}, state.maxLimits), {}, {
        spendLimitRemaining: newLimit
      });
    }
  },
  extraReducers(builder) {
    builder.addCase(instantPayClear.fulfilled, state => {
      state.instantPay = {};
    });
  }
});
svs.accountservicesReact.deposit.store.deposit = svs.accountservicesReact.deposit.store.deposit || {};
svs.accountservicesReact.deposit.store.deposit.actions = _objectSpread({
  instantPayClear
}, depositSlice.actions);
svs.accountservicesReact.deposit.store.deposit.reducer = depositSlice.reducer;
svs.accountservicesReact.deposit.store.deposit.initialState = getInitialState();

 })(window);